// /src/app/ResetSenha/resetsenha.jsx

import React, { useState } from "react";
import { Link } from 'react-router-dom';
import './resetsenha.css';

// Apenas a importação necessária é mantida
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../Config/firebase';

function ResetSenha(){

    const [email, setEmail] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('');
    const [loading, setLoading] = useState(false); // Novo estado para feedback de carregamento

    // Função refatorada para async/await e melhor tratamento de erros
    async function recuperarSenha(e) {
        e.preventDefault(); // Previne o recarregamento da página
        setMensagem('');
        setSucesso('');

        if (!email){
            setMensagem('Por favor, informe seu e-mail.');
            return;
        }

        setLoading(true);

        try {
            await sendPasswordResetEmail(auth, email);
            setSucesso('E-mail de recuperação enviado com sucesso! Verifique sua caixa de entrada e spam.');
        } catch (error) {
            // Tratamento de erro baseado no código, que é mais estável
            if (error.code === 'auth/invalid-email') {
                 setMensagem('O e-mail informado é inválido.');   
            } else if (error.code === 'auth/user-not-found') {
                setMensagem('Não há nenhuma conta cadastrada com este e-mail.');
            } else {
                setMensagem('Ocorreu um erro ao tentar enviar o e-mail. Tente novamente.');
                console.error("Erro ao resetar senha:", error);
            }
        } finally {
            setLoading(false); // Garante que o estado de loading termine
        }
    }

    return (
        <div className="d-flex align-items-center text-center form-container">
            {/* Alterado para tag <form> com evento onSubmit */}
            <form className="form-signin" onSubmit={recuperarSenha}>

                <img className="mb-4" src="/imagens/logo_fundo_branco_pequena.png" alt="Logo R6 ERP" />

                <h1 className="h3 mb-3 fw-normal">Recuperar senha</h1>

                <div className="form-floating">
                    <input 
                        onChange={event => setEmail(event.target.value)} 
                        type="email" 
                        className="form-control" 
                        id="floatingInput" 
                        placeholder="E-mail"
                        required
                    />
                    <label htmlFor="floatingInput">E-mail</label>
                </div>

                <button 
                    className="btn btn-primary w-100 py-2" 
                    type="submit" 
                    disabled={loading}
                >
                    {loading ? 'Enviando...' : 'Enviar'}
                </button>

                {/* Mensagens de feedback renderizadas de forma condicional */}
                {mensagem && <div className="alert alert-danger mt-3" role="alert">{mensagem}</div>}
                {sucesso && <div className="alert alert-success mt-3" role="alert">{sucesso}</div>}

                <div className="login-links mt-5">
                    <Link to="/app" className="mx-3">Voltar para o login</Link>
                </div>
                <p className="mt-5 mb-3 text-body-secondary">&copy; Desenvolvido por R6 Software</p>
            </form>
        </div>
    );
}

export default ResetSenha;